// ABOUTME: Index of the listNames of the nodes the link contents of the search result nodes point to, by node id.
// ABOUTME: The data-table drops these fields from its rows, so the link cells read them here; a missing name leaves the code.

export type LinkListName = { hierarchyId: string; code: string; listName?: string | null };

/** node id → (linked hierarchy + code → listName), for the nodes of one search page. */
export type LinkListNamesIndex = Map<string, Map<string, string>>;

type SearchEdge =
    | { node?: { id?: string | null; linkListNames?: LinkListName[] | null } | null }
    | null
    | undefined;

const linkKey = (hierarchyId: string, code: string) => `${hierarchyId}\u0000${code}`;

export const indexLinkListNames = (edges: SearchEdge[]): LinkListNamesIndex =>
    new Map(
        edges
            .map(edge => edge?.node)
            .filter(
                (node): node is { id: string; linkListNames: LinkListName[] } =>
                    !!node?.id && !!node.linkListNames?.length,
            )
            .map(node => [
                node.id,
                new Map(
                    node.linkListNames
                        .filter(link => !!link.listName)
                        .map(link => [
                            linkKey(link.hierarchyId, link.code),
                            link.listName as string,
                        ]),
                ),
            ]),
    );

/** The label of a link value of a row: the linked node's listName, else the code itself. */
export const resolveLinkLabel = (
    index: LinkListNamesIndex | undefined,
    rowId: string,
    hierarchyId: string,
    code: string,
): string => index?.get(rowId)?.get(linkKey(hierarchyId, code)) || code;
